import { useRouter } from 'next/router'

function useLocale(): string {
  const router = useRouter()
  return router?.locale as string
}

export default useLocale
